import React from 'react';
import Header from '../Header/Header';
import './Homepage.css';

import MainBody from '../MainBody/MainBody';

const Homepage = () => {
    return (
        <div className="body">
            <Header></Header>
            <MainBody></MainBody>

           
            

        </div>
    );
};

export default Homepage;